// FILE: src/components/Signup.js
import React, { useState } from "react";
import { auth, db } from "../firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const Signup = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cellNumber, setCellNumber] = useState("");
  const [homeAddress, setHomeAddress] = useState(""); // optional
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setMessage("Signing up…");

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // ✅ Force all new users to be members
      const role = "member";

      // users/{uid}
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email,
        firstName,
        lastName,
        displayName: `${firstName} ${lastName}`.trim(),
        cellNumber,
        homeAddress: homeAddress || "",
        membershipStatus: "active",
        role, // always "member"
        createdAt: serverTimestamp(),
      });

      // ✅ Always create members/{uid} for new signups
      await setDoc(doc(db, "members", user.uid), {
        uid: user.uid,
        email,
        firstName,
        lastName,
        cellNumber,
        homeAddress: homeAddress || "",
        membershipStatus: "active",
        createdAt: serverTimestamp(),
      });

      setMessage("Signup successful! Redirecting to login…");
      navigate("/login", { state: { email, password } });
    } catch (error) {
      console.error("Signup error:", error);
      setMessage(error.message || "Signup failed");
    }
  };

  return (
    <div className="max-w-md mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">Sign Up</h2>

      <form onSubmit={handleSignup} className="space-y-3">
        <input
          type="text"
          placeholder="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          required
          className="w-full p-2 border rounded"
        />

        <input
          type="text"
          placeholder="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          required
          className="w-full p-2 border rounded"
        />

        <input
          type="tel"
          placeholder="Cell Number (e.g. 082 123 4567)"
          value={cellNumber}
          onChange={(e) => setCellNumber(e.target.value)}
          required
          className="w-full p-2 border rounded"
        />

        <textarea
          placeholder="Home Address (optional)"
          value={homeAddress}
          onChange={(e) => setHomeAddress(e.target.value)}
          className="w-full p-2 border rounded"
          rows={2}
        />

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full p-2 border rounded"
        />

        <input
          type="password"
          placeholder="Password (min 6 characters)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full p-2 border rounded"
        />

        <button type="submit" className="w-full py-2 bg-indigo-600 text-white rounded">
          Sign Up
        </button>

        <p className="text-xs text-gray-500 text-center">
          Your personal information is protected and handled in accordance with the
          Protection of Personal Information Act (POPIA). We do not share your details
          with third parties without your consent.
        </p>
      </form>

      <p className="mt-3 text-sm text-gray-600">{message}</p>
    </div>
  );
};

export default Signup;